import * as yup from 'yup';

import { isValidUrl } from '@@/form-components/validate-url';

const channelNameSchema = yup.string().required('Name is required');

const webhookUrlSchema = yup
  .string()
  .required('Webhook URL is required')
  .test('valid-url', 'Invalid URL format', (value) =>
    value ? isValidUrl(value) : false
  );

const slackChannelConfigSchema = yup.object({
  name: channelNameSchema,
  api_url: webhookUrlSchema,
});

const webhookChannelConfigSchema = yup.object({
  name: channelNameSchema,
  url: webhookUrlSchema,
});

const msTeamsChannelConfigSchema = yup.object({
  name: channelNameSchema,
  webhook_url: webhookUrlSchema,
});

const emailChannelConfigSchema = yup.object({
  name: channelNameSchema,
  smtp_server: yup.string().required('SMTP Server is required'),
  auth_username: yup.string().optional(),
  auth_password: yup.string().optional(),
  email_to: yup
    .string()
    .required('To Email Address is required')
    .email('Invalid email format'),
  email_from: yup
    .string()
    .required('From Email Address is required')
    .email('Invalid email format'),
});

const defaultChannelConfigSchema = yup.object({
  name: channelNameSchema,
});

function getChannelConfigSchema(type: unknown) {
  const channelType = Array.isArray(type) ? type[0] : type;

  switch (channelType) {
    case 'slack':
      return slackChannelConfigSchema;
    case 'webhook':
      return webhookChannelConfigSchema;
    case 'msteamsv2':
      return msTeamsChannelConfigSchema;
    case 'email':
      return emailChannelConfigSchema;
    default:
      return defaultChannelConfigSchema;
  }
}

export const validationSchema = yup.object({
  name: yup.string().required('Name is required'),
  enabled: yup.boolean().required(),
  notificationChannels: yup.array().of(
    yup.object({
      name: yup.string().required('Channel name is required'),
      type: yup.string().required('Channel type is required'),
      config: yup
        .object()
        .when('type', (type: unknown) => getChannelConfigSchema(type)),
    })
  ),
});
